var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "arrow-bearish2",
    width: 11.412,
    height: 6.848,
    viewBox: "0 0 11.412 6.848",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_1590",
    "data-name": "Path 1590",
    d: "M13.36,12.495a.579.579,0,0,1-.525.354H9.983a.57.57,0,0,1,0-1.141h1.477L8.272,8.519,6.4,10.4a.57.57,0,0,1-.81,0L2.163,6.979a.573.573,0,1,1,.81-.81L5.99,9.192,7.867,7.31a.57.57,0,0,1,.81,0L12.265,10.9V9.426a.57.57,0,1,1,1.141,0v2.852A.57.57,0,0,1,13.36,12.495Z",
    transform: "translate(-1.994 -6)",
    fill: "#ED3432"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownArrow);
export default __webpack_public_path__ + "static/media/down-arrow.198984e8bdbf9845f3fb1c8a671eff85.svg";
export { ForwardRef as ReactComponent };